import { render, staticRenderFns } from "./NomeParlamentarComPalavra.vue?vue&type=template&id=d5cfe6e8&scoped=true&"
import script from "./NomeParlamentarComPalavra.vue?vue&type=script&lang=js&"
export * from "./NomeParlamentarComPalavra.vue?vue&type=script&lang=js&"
import style0 from "./NomeParlamentarComPalavra.vue?vue&type=style&index=0&id=d5cfe6e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5cfe6e8",
  null
  
)

export default component.exports